module.exports = __webpack_public_path__ + "img/worx.738706ac.jpg";